import styled, { css, keyframes } from 'styled-components'
import { UnstyledButton, Article as _Article } from '../_Common/lot.common.styles'
import { theme } from '@/styles/theme'

export const Article = styled(_Article)`
  th {
    color: ${theme.colors.buttons.text.default};
  }
  h3,
  h4,
  p {
    color: ${theme.palette.ink};
  }
  position: relative;
  container-type: inline-size;
  gap: 24px;
  h2 {
    background-color: white;
  }
`
const threeRow = `${280 + 32 + 40 * 8 + 2 * 7}px` //614px
const twoRow = `${280 + 32 + 40 * 6 + 2 * 7}px` //530px
const oneRow = `${280 + 32 + 40 * 4 + 2 * 3}px` //446px

export const Container = styled.div`
  display: flex;

  margin: 8px 0;
  gap: 16px;
  @container (width < ${oneRow}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export type AnimationName = 'blink' | 'open' | 'close'
export const Section = styled.fieldset<{
  $visible?: boolean
  $first: boolean
  $animationName?: AnimationName
}>`
  //reset fieldset
  display: block;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  //
  @keyframes appear {
    0% {
      opacity: 0.1;
    }
    80% {
      opacity: 0.2;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes open {
    from {
      height: 0px;
    }
    to {
      height: 40px;
    }
  }
  @keyframes close {
    from {
      height: 40px;
    }
    to {
      height: 0px;
    }
  }
  @keyframes blink {
    0% {
      height: 40px;
    }
    40% {
      height: 0px;
    }
    80% {
      height: 0px;
    }
    100% {
      height: 40px;
    }
  }
  ${({ $visible, $first, $animationName = 'blink' }) => {
    return $visible
      ? css`
          animation: ${$first ? 'appear' : ''} 0s ease forwards;
          button {
            animation: ${$first ? 'open' : $animationName} 0.3s ease forwards;
          }
        `
      : css`
          visibility: hidden;
          animation: none;
        `
  }}

  border-color: transparent;
  display: ${({ $visible }) => ($visible ? 'grid' : 'none')};
  grid-template-columns: repeat(8, 40px);
  grid-template-rows: 21px repeat(5, 40px);
  gap: 2px;
  #date {
    grid-column: 2 / span 8;
    display: flex;
    align-items: center;
    h3 {
      margin: 0 0 16px;
      font-size: clamp(12px, 3cqw, 18px);
    }
  }
  @container (width < ${threeRow}) {
    grid-template-columns: repeat(6, 40px);
    #date {
      grid-column: 2 / span 6;
    }
  }
  @container (width < ${twoRow}) {
    grid-template-columns: repeat(4, 40px);
    #date {
      grid-column: 2 / span 4;
    }
  }
  @container (width < ${oneRow}) {
    grid-template-columns: repeat(8, 40px);
    grid-column: 2 / span 8;
    #date {
      grid-column: 2 / span 8;
    }
  }
`

export const TimeSlot = styled.button`
  border: 0;
  padding: 0;

  grid-column: span 2;
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
  border: 1px solid ${theme.palette.bottlebrushGreen};

  cursor: pointer;
  border-radius: 4px;
  background-color: white;
  color: ${theme.colors.buttons.text.default};
  &:hover {
    background: ${theme.palette.bottlebrushGreen};
    color: ${theme.palette.softPaper};
  }
  &:active {
    background: ${theme.palette.bushlandDeep};
    color: ${theme.palette.softPaper};
  }

  time {
  }
`

export const Table = styled.table`
  /* overflow: hidden; */
  table-layout: fixed;
  border-collapse: collapse;
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  height: 230px;
`
export const THead = styled.thead``
export const Tbody = styled.tbody`
  border-collapse: collapse;
  border-spacing: 0;
`
export const Tr = styled.tr`
  border-collapse: collapse;
  border-spacing: 0;
  border-width: 0;
  height: 40px;
`
export const Td = styled.td`
  box-sizing: content-box;
  width: 40px;
  height: 40px;
  min-width: 40px;
  max-width: 40px;
  min-height: 40px;
  max-height: 40px;
  padding: 0;
  border-spacing: 0;
  padding: 1px;

  position: relative;
  div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    display: grid;
    place-items: center;
  }
`
const zoomIn = (size: 'sm' | 'md') => keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
    translate: 0px 0px;
  }
  50% {
    opacity: 0.7;
  }
  80% {
    transform: scale(5);
    opacity: 0.7;
    translate: var(--translate-offset-center); 
  }
  100% {
    opacity: 1;
    transform: scale(1);
    translate: ${size === 'sm' ? 'var(--translate-offset-end-sm)' : 'var(--translate-offset-end-md)'};
  }
`
export const Button = styled(UnstyledButton)<{ $active?: Boolean; $cellPlace: [number, number] }>`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  transition: background-color 0.3s ease-in;
  --translate-offset-center: 0px 0px;
  --translate-offset-end-sm: 0px 0px;
  --translate-offset-end-md: 0px 0px;

  /* background: #ccc; */
  color: ${theme.colors.buttons.text.default};
  background-color: ${theme.colors.buttons.background.default};
  &:hover:not(&:disabled) {
    /* ${({ $active }) => !$active && 'background: #999;'} */
    ${({ $active }) =>
      !$active &&
      css`
        background-color: ${theme.colors.buttons.background.hover};
      `}
  }
  &:active {
    background-color: ${theme.colors.buttons.background.active};
  }
  &.noAppointments {
    background-color: ${theme.colors.buttons.background.disabled};
    color: ${theme.colors.buttons.text.subtle};
    color: ${theme.colors.buttons.text.default};
  }

  &:disabled {
    /* background: #eee; */
    background-color: ${theme.colors.buttons.background.disabled};
    color: ${theme.colors.buttons.text.disabled};
  }

  ${({ $active }) =>
    $active
      ? css`
          /* background: #555; */
          background-color: ${theme.colors.buttons.background.active};
          color: ${theme.colors.buttons.text.active};
          z-index: 5;
          animation: ${zoomIn('md')} 0.6s ease forwards;
          @container (width < ${oneRow}) {
            animation: ${zoomIn('sm')} 0.6s ease forwards;
          }
          border: 2 px solid buo;
        `
      : 'translate: 0 0'}
`
export const A = styled.a`
  display: inline-flex;
  gap: 4px;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline ${theme.colors.buttons.text.default};
  }
`
export function moveCellToCenter(targetRow, targetCol, centerRow = 2, centerCol = 3, x = 0, y = 0) {
  // Target dimensions
  const cellWidth = 40 // Must match CSS width
  const cellHeight = 42 // Must match CSS height

  // Center coordinates (0-based index)
  //   const centerRow = 2
  //   const centerCol = 3

  // Calculate the difference in rows and columns
  const rowOffset = targetRow - centerRow
  const colOffset = targetCol - centerCol

  // Calculate the total distance to move in pixels/units
  // We negate the value because we want to move *back* towards the center point (0,0)
  const translateX = -(colOffset * cellWidth)
  const translateY = -(rowOffset * cellHeight)

  return [translateX + x, translateY + y]
}

export function moveCellPx(targetRow, targetCol, centerRow = 2, centerCol = 3, xPx = 0, yPx = 0) {
  const [x, y] = moveCellToCenter(targetRow, targetCol, centerRow, centerCol, xPx, yPx)
  return `${x}px ${y}px`
}

/* 

  ${({ $cellPlace, $cellPlace: [x, y] }) => css`
    @keyframes zoomIn${$cellPlace.join('')} {
      0% {
        transform: scale(1);
        opacity: 1;
        translate: 0px 0px;
      }
      50% {
        opacity: 0.7;
      }
      80% {
        transform: scale(5);
        opacity: 0.7;
        border-radius: 25px;
        ${(([x, y] = moveCellToCenter(x, y)), `translate: ${x}px ${y}px;`)}
      }
      100% {
        transform: scale(1);
        opacity: 1;
        z-index: 2;
        ${(([x, y] = moveCellToCenter(x, y, 1, 4, 16)), `translate: ${x}px ${y}px;`)};
      }
    }
  `}
  
  */
export const Small = styled.small`
  position: absolute;
  bottom: 12px;
  right: 4px;
  font-size: x-small;
  font-style: italic;
  color: ${theme.palette.bushlandDeep};
  a {
    font-style: normal;
    color: ${theme.palette.jacarandaDeep};
  }
`